/* eslint-disable import/no-anonymous-default-export */
import React from 'react';
import { Routes, Route } from 'react-router';
import ReferredPatients from '../components/pages/referrals';
import QueueLabWork from '../components/pages/QueueLabWork';
import Procedures from '../components/pages/Procedures';
import ProcedureEdits from '../components/pages/ProcedureEdits';
import Dashboard from '../components/pages/Dashboard';
import Patients from '../components/pages/Patients';
import WalkIn from '../components/pages/WalkIn';
// import Facility from '../components/pages/Facility';
// import CustomerEngagement from '../components/pages/CustomerEngagement';
import PatientDetails from '../components/pages/PatientDetails';
import AuthRoute from './AuthRoute';
// import PatientsFinance from '../components/pages/Finance';
// import PatientsInsurance from '../components/pages/Pinsurance';
// import ReferredPatients from '../components/pages/referrals';
import AddPatients from '../components/pages/AddPatients';
import { useNavigate } from "react-router-dom";
// import PatientHMOetails from '../components/pages/PatientHmoDetails';
import SignUp from '../components/pages/SignUp';
import CostSetup from '../components/pages/CostSetup';
import ProfileUpdatePage from '../components/pages/ProfileUpdatePage';
import SubmitFeedback from '../components/pages/SubmitFeedback';
import NotificationPage from '../components/pages/Notification';
import WalkInPatients from '../components/pages/WalkinPatients';
import CHPMembers from '../components/pages/CHPMembers';
import PatientQueue from '../components/pages/PatientQueue';
import Reports from '../components/pages/Reports';
// import LabReportTemplates from '../components/pages/LabTemplates';
import Settings from '../components/pages/Settings';
import ApprovedRequests from '../components/pages/ApproveRequests';
import ManageProcedures from '../components/pages/ManageProcedures';
import PaymentRecords from '../components/pages/PaymentRecords';


export default () => {

    return (
        <Routes>
            <Route path="/referrals" element={<ReferredPatients />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/queue-lab-work" element={<QueueLabWork />} />
            <Route path="/procedures" element={<Procedures />} />
            <Route path="/review-procedures" element={<ManageProcedures />} />
            <Route path="/procedure-edits" element={<ProcedureEdits />} />
            <Route path="/dashboard" element={<AuthRoute><Dashboard /></AuthRoute>} />
            <Route path="/onboard" element={<AuthRoute><Patients /> </AuthRoute>} />
            <Route path="/walk-in" element={<AuthRoute><WalkIn /> </AuthRoute>} />
            <Route path="/patients" element={<AuthRoute><WalkInPatients /> </AuthRoute>} />
            <Route path="/notifications" element={<AuthRoute><NotificationPage /> </AuthRoute>} />
            <Route path="/patient-details" element={<AuthRoute><PatientDetails /></AuthRoute>} />
            <Route path="/patients-queue" element={<AuthRoute><PatientQueue /></AuthRoute>} />
            <Route path="/CHP-members" element={<AuthRoute><CHPMembers /></AuthRoute>} />
            {/* <Route path="/patient-hmo-details" element={<AuthRoute><PatientHMOetails/></AuthRoute>} /> */}
            <Route path="/patients/add" element={<AuthRoute><AddPatients /></AuthRoute>} />
            <Route path="/cost-setup" element={<AuthRoute><CostSetup /></AuthRoute>} />
            <Route path="/profile" element={<AuthRoute><ProfileUpdatePage /></AuthRoute>} />
            <Route path="/approve-requests" element={<AuthRoute><ApprovedRequests /></AuthRoute>} />
            <Route path="/submit-feedback" element={<AuthRoute><SubmitFeedback /></AuthRoute>} />
            <Route path="/payment-records" element={<AuthRoute><PaymentRecords /></AuthRoute>} />
            <Route path="/settings" element={<AuthRoute><Settings /></AuthRoute>} />
        </Routes>
    )

};
